module.exports = __webpack_public_path__ + "img/research_5.1ed0b3d0.jpg";